import $ from 'jquery'
import './index.styl'

const tpl = (content, opt={}) => `
    ${opt.modal?`<div class="cd-modal">`:''}
        <div class="cd-modal-content" style="${opt.style}">
            ${opt.noClose?'':`<div class="close close-btn"></div>`}
            ${content}
        </div>
    ${opt.modal?`</div>`:''}
`

export default class {
    constructor(...args){
        this.content = $(tpl(...args)).hide()
        $("body").append(this.content)
        this.content.find(".close").on("click",()=>{
            this.hide()
        })
    }
    show(){
        this.content.fadeIn()
    }
    hide(){
        this.content.fadeOut()
    }
}